export const FINGO_MASTER_ENTITY_RUT = 77201556;
export const PLATFORM_MASTER_ENTITY_RUT = process.env.REACT_APP_PLATFORM_MASTER_ENTITY_RUT;

export const huntingFarmingFilterOptions = (allLabel = 'Todos') => [
  {
    label: allLabel,
    value: 'ALL',
    key: 'everyInvoice',
  },
  {
    label: 'Farming',
    value: 'Farming',
    key: 'farmingInvoice',
  },
  {
    label: 'Hunting',
    value: 'Hunting',
    key: 'huntingInvoice',
  },
];

export default FINGO_MASTER_ENTITY_RUT;
